import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'
import { OrganizationsService } from 'src/app/modules/organization/services/organizations.service'
import { ActivatedRoute, Router } from '@angular/router'
import { SharedService } from 'src/app/shared/services/shared.service'
import { environment } from 'src/environments/environment'

import { DateRange, MatCalendar } from '@angular/material/datepicker'

import {
	DefaultMatCalendarRangeStrategy,
	MatRangeDateSelectionModel,
} from '@angular/material/datepicker'
import {
	financeFilter,
	financeList,
} from 'src/app/modules/wallet/models/finance.models'
import { WalletService } from '../../services/wallet.service'
import * as moment from 'moment'

@Component({
	selector: 'app-financial-list',
	templateUrl: './financial-list.component.html',
	styleUrls: ['./financial-list.component.scss'],
	providers: [DefaultMatCalendarRangeStrategy, MatRangeDateSelectionModel],
})
export class FinancialListComponent implements OnInit, OnDestroy {
	@ViewChild('calendar') calendar!: MatCalendar<moment.Moment | Date>
	subscription = new Subscription()
	activeCountries!: any
	totals!: any

	financialFilter: financeFilter = {
		countryId: 224,
		searchText: '',
		activeTab: 0,
		startDate: null,
		endDate: null,
		serviceProviderId: null,
		branchId: null,
		clientId: null,
		paging: {
			pageNumber: 1,
			pageSize: 10,
		},
		fixedAmount: null,
		fromAmount: null,
		toAmount: null,
	}
	listData!: financeList[]
	filterCount = 0
	totalCount = 0
	attachmentUrl: string = environment.attachmentPath

	open = true
	selectedDateRange: DateRange<Date> | undefined
	dateChange = false
	constructor(
		public translate: TranslateService,
		private organizationServ: OrganizationsService,
		private ActivatedRoute: ActivatedRoute,
		private router: Router,
		private SharedService: SharedService,
		private readonly selectionModel: MatRangeDateSelectionModel<Date>,
		private readonly selectionStrategy: DefaultMatCalendarRangeStrategy<Date>,
		private WalletService: WalletService
	) {}

	ngOnInit(): void {
		this.SharedService.headerTitle.next(`Finance`)
		this.getActiveCountries()
		this.subscription.add(
			this.ActivatedRoute.queryParams.subscribe((res) => {
				this.financialFilter.countryId = res['country'] || 224
				this.financialFilter.activeTab = res['status'] || 1
				this.financialFilter.paging.pageNumber = res['page'] || 1
				this.financialFilter.paging.pageSize = res['count'] || 10
				this.SharedService.handleBreadCrumb('finance-list', true, {
					name: '',
					id: '',
					url: '/layout/wallet/financial-list',
					queryParams: { ...res },
				})
				this.getListData()
			})
		)
	}

	getActiveCountries() {
		this.subscription.add(
			this.organizationServ.getActiveCountries().subscribe((res: any) => {
				this.activeCountries = res
			})
		)
	}
	reset() {
		this.financialFilter.startDate = null
		this.financialFilter.endDate = null
		this.selectedDateRange = undefined
		this.calendar.activeDate = moment(new Date())
		this.dateChange = false
		this.getListData()
	}
	getListData(search = false, filter: any = null) {
		search
			? (this.financialFilter.paging.pageNumber = 1)
			: this.financialFilter.paging.pageNumber

		filter
			? (this.financialFilter = { ...this.financialFilter, ...filter })
			: this.financialFilter

		this.subscription.add(
			this.WalletService.getFinanceList(this.financialFilter).subscribe(
				(res: any) => {
					this.totals = res?.result?.totals
					this.listData = res.result
					console.log(this.listData)

					this.financialFilter.activeTab <= 3 ||
					this.financialFilter.activeTab == 6
						? (this.totalCount = res.result.payments.totalCount)
						: (this.totalCount = res.result.funds.totalCount)
				}
			)
		)
	}
	rangeChanged(selectedDate: Date) {
		const selection = this.selectionModel.selection,
			newSelection = this.selectionStrategy.selectionFinished(
				selectedDate,
				selection
			)

		this.selectionModel.updateSelection(newSelection, this)
		this.dateChange = true
		this.selectedDateRange = new DateRange<Date>(
			newSelection.start,
			newSelection.end
		)

		this.financialFilter.startDate = this.selectedDateRange.start
		this.financialFilter.endDate = this.selectedDateRange.end
		this.getListData()
	}
	pageChanged(pageNumber: number, pagecount: number) {
		this.financialFilter.paging.pageNumber = pageNumber
		this.financialFilter.paging.pageSize = pagecount

		this.router.navigate(['/layout/wallet/financial-list'], {
			queryParams: {
				country: this.financialFilter.countryId,
				status: this.financialFilter.activeTab,
				page: pageNumber,
				count: pagecount,
			},
		})
		this.getListData()
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe()
	}
}
